import { useEffect, useState } from 'react';

import { productionApi } from 'api/production';
import { getWeekNumber, getWeekYear } from 'utils/dateUtils/dateUtils';

/**
 * Fetches and manages the pack groups for a given date.
 *
 * @param {Date} date - The date to fetch pack groups for
 * @returns {Object} - Hook return object
 * @returns {boolean} loading - Whether the pack groups are loading
 * @returns {Array} packGroups - The list of pack groups
 */
export function usePackGroups(date) {
    const [loading, setLoading] = useState(true);
    const [packGroups, setPackGroups] = useState();

    useEffect(() => {
        const fetchPackGroups = async () => {
            if (!date || !(date instanceof Date)) {
                return;
            }

            try {
                setLoading(true);
                const response = await productionApi.getPackGroups({
                    week: getWeekNumber(date, 'YYYY-MM-DD'),
                    year: getWeekYear(date, 'YYYY-MM-DD'),
                });
                const { packGroups: packGroupsData } = response.data;
                setPackGroups(packGroupsData);
            } catch (error) {
                console.error('Error fetching pack groups:', error);
            } finally {
                setLoading(false);
            }
        };
        fetchPackGroups();
    }, [date]);

    return { loading, packGroups };
}
